import { jsx } from "react/jsx-runtime";
import { Path, SVG } from "@wordpress/primitives";
var align_none_default = /* @__PURE__ */ jsx(SVG, { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx(Path, { d: "M19 5.5H5V4h14v1.5ZM19 20H5v-1.5h14V20ZM5 9h14v6H5V9Z" }) });
export {
  align_none_default as default
};
//# sourceMappingURL=align-none.js.map
